import { call, put, takeLatest } from 'redux-saga/effects';
import { API } from '../api';
import { CHANGE_ROLE, GET_USER, CREATE_USER, DELETE_USER, FETCH_USER, UPDATE_USER, FETCH_FLEET_MEMBERS, UPDATE_USER_GST, TOGGLE_INDEPENDENT_WALLET, GET_WEEKLY_PERFORMANCE_EMAIL, UPDATE_WEEKLY_PERFORMANCE_EMAIL } from 'actions/user';

function* getUsers(action) {
  try {
    const response = yield call(API.getUsers, action.payload);
    yield put({ type: FETCH_USER.SUCCESS, payload: response });
    action.cb && action.cb(response);
  } catch (e) {
    yield put({ type: FETCH_USER.FAIL, payload: { error: e } });
  }
}

function* createUser(action) {
  try {
    const response = yield call(API.addUser, action.payload);
    yield put({ type: CREATE_USER.SUCCESS, payload: response.data });
    action.cb && action.cb(response);
  } catch (e) {
    yield put({ type: CREATE_USER.FAIL, payload: { error: e } });
  }
}

function* changeRole(action) {
  try {
    const response = yield call(API.updateUser, action.payload);
    yield put({ type: CHANGE_ROLE.SUCCESS, payload: response.data });
    action.cb && action.cb(response);
  } catch (e) {
    yield put({ type: CHANGE_ROLE.FAIL, payload: { error: e } });
  }
}

function* updateUser(action) {
  try {
    const response = yield call(API.updateUser, action.payload);

    if (response?.data?.success === false) {
      yield put({ type: UPDATE_USER.FAIL, payload: { error: response.data.message } });
      return;
    }

    yield put({ type: UPDATE_USER.SUCCESS, payload: response.data });
    action.cb && action.cb(response);
  } catch (e) {
    yield put({ type: UPDATE_USER.FAIL, payload: { error: e } });
  }
}

function* deleteUser(action) {
  try {
    yield call(API.deleteUser, action.payload);
    yield put({ type: DELETE_USER.SUCCESS, payload: action.payload });
  } catch (e) {
    yield put({ type: DELETE_USER.FAIL, payload: { error: e } });
  }
}

function* getFleetMembers(action) {
  try {
    const response = yield call(API.getFleetMembers, action.payload);
    yield put({ type: FETCH_FLEET_MEMBERS.SUCCESS, payload: response });
    action.cb && action.cb(response);
  } catch (e) {
    yield put({ type: FETCH_FLEET_MEMBERS.FAIL, payload: { error: e } });
  }
}

function* updateUserGst(action) {
  try {
    const response = yield call(API.updateUserGst, action.payload);
    yield put({ type: UPDATE_USER_GST.SUCCESS, payload: response.data });
    action.cb && action.cb(response);
  } catch (e) {
    yield put({ type: UPDATE_USER_GST.FAIL, payload: { error: e } });
  }
}

function* getUserById(action) {
  try {
    const userId = action.payload?.id || action.payload?.userId || action.payload;
    const response = yield call(API.getUserById, userId);
    yield put({ type: GET_USER.SUCCESS, payload: response.data });
    action.cb && action.cb(response);
  } catch (e) {
    yield put({ type: GET_USER.FAIL, payload: { error: e } });
  }
}

function* toggleIndependentWallet(action) {
  try {
    const response = yield call(API.toggleIndependentWallet, action.payload);
    yield put({ type: TOGGLE_INDEPENDENT_WALLET.SUCCESS, payload: response.data });
    action.cb && action.cb(response);
  } catch (e) {
    yield put({ type: TOGGLE_INDEPENDENT_WALLET.FAIL, payload: { error: e } });
  }
}

function* getWeeklyPerformanceEmail(action) {
  try {
    const response = yield call(API.getWeeklyPerformanceEmail, action.payload);
    yield put({ type: GET_WEEKLY_PERFORMANCE_EMAIL.SUCCESS, payload: response.data });
    action.cb && action.cb(response);
  } catch (e) {
    yield put({ type: GET_WEEKLY_PERFORMANCE_EMAIL.FAIL, payload: { error: e } });
    action.cb && action.cb(e?.response);
  }
}

function* updateWeeklyPerformanceEmail(action) {
  try {
    const response = yield call(API.updateWeeklyPerformanceEmail, action.payload);
    yield put({ type: UPDATE_WEEKLY_PERFORMANCE_EMAIL.SUCCESS, payload: response.data });
    action.cb && action.cb(response);
  } catch (e) {
    yield put({ type: UPDATE_WEEKLY_PERFORMANCE_EMAIL.FAIL, payload: { error: e } });
    action.cb && action.cb(e?.response);
  }
}

function* user() {
  yield takeLatest(FETCH_USER.REQUEST, getUsers);
  yield takeLatest(CREATE_USER.REQUEST, createUser);
  yield takeLatest(DELETE_USER.REQUEST, deleteUser);
  yield takeLatest(UPDATE_USER.REQUEST, updateUser);
  yield takeLatest(CHANGE_ROLE.REQUEST, changeRole);
  yield takeLatest(FETCH_FLEET_MEMBERS.REQUEST, getFleetMembers);
  yield takeLatest(UPDATE_USER_GST.REQUEST, updateUserGst);
  yield takeLatest(GET_USER.REQUEST, getUserById);
  yield takeLatest(TOGGLE_INDEPENDENT_WALLET.REQUEST, toggleIndependentWallet);
  yield takeLatest(GET_WEEKLY_PERFORMANCE_EMAIL.REQUEST, getWeeklyPerformanceEmail);
  yield takeLatest(UPDATE_WEEKLY_PERFORMANCE_EMAIL.REQUEST, updateWeeklyPerformanceEmail);
}

export default user;
